import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import DashboardLayout from '../../components/Layout/DashboardLayout'
import Sidebar from '../../components/Sidebar/Sidebar'
import HospitalSelector from '../../components/Header/HospitalSelector'
import StatusAtGlance from './StatusAtGlance'
import Screening from './Screening'
import PatientEducation from './PatientEducation'
import ProviderEducation from './ProviderEducation'
import OutcomeMeasures from './OutcomeMeasures'
import StructureMeasures from './StructureMeasures'

const RedirectWithParams: React.FC<{ to: string }> = ({ to }) => {
    const location = useLocation()
    return <Navigate to={`${to}${location.search}`} replace />
}

const PMHIndex: React.FC = () => {
    const sidebarLinks = [
        { label: 'Status at a Glance', path: '/pmh/status/' },
        { label: 'Structure Measures', path: '/pmh/structure-measures/' },
        {
            label: 'Process Measures',
            path: '',
            submenu: [
                { label: 'Clinical Team Education', path: '/pmh/provider-education/' },
                { label: 'Patient Education', path: '/pmh/patient-education/' },
                { label: 'Screening', path: '/pmh/screening/' },
            ]
        },
        { label: 'Outcome Measures', path: '/pmh/outcome/' },
    ]

    const exportPages = [
        { url: '/pmh/status/', title: 'Status at a Glance' },
        { url: '/pmh/structure-measures/', title: 'Structure Measures' },
        { url: '/pmh/provider-education/', title: 'Clinical Team Education' },
        { url: '/pmh/patient-education/', title: 'Patient Education' },
        { url: '/pmh/screening/', title: 'PMH Screening' },
        { url: '/pmh/outcome/', title: 'Outcome Measures' },
    ]

    const sidebar = (
        <Sidebar
            logo="/logo1.webp"
            links={sidebarLinks}
            exportPages={exportPages}
            exportTitle="PMH Designation Dashboard"
        />
    )

    const header = <HospitalSelector />

    return (
        <DashboardLayout sidebar={sidebar} header={header}>
            <Routes>
                <Route path="/" element={<RedirectWithParams to="/pmh/status/" />} />

                <Route path="/status/" element={<StatusAtGlance />} />
                <Route path="/screening/" element={<Screening />} />
                <Route path="/patient-education/" element={<PatientEducation />} />
                <Route path="/provider-education/" element={<ProviderEducation />} />
                <Route path="/outcome/" element={<OutcomeMeasures />} />
                <Route path="/structure-measures/" element={<StructureMeasures />} />
                <Route path="*" element={<RedirectWithParams to="/pmh/status/" />} />
            </Routes>
        </DashboardLayout>
    )
}

export default PMHIndex
